// extracted by mini-css-extract-plugin
export default {"filterPanel":"projectsFilterPanel_filterPanel__ibqZR","addNewProjBtn":"projectsFilterPanel_addNewProjBtn__-uymU","dashboardBtn":"projectsFilterPanel_dashboardBtn__hbYV2"};